import Vuex from 'vuex';
import Vue from 'vue';

import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import state from './state';
import modules from './modules';

Vue.use(Vuex);

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations,  
  modules,
})



// WEBPACK FOOTER //
// ./src/store/index.js